import { useState } from 'react';
import { openOneDrivePicker } from './helper.js';
import './OneDriveFileButton.css';

function OneDriveFileButton({ onFilesSelected, onFolderSelected, mode = 'files', isUploading, buttonLabel, showText = false, filters }) {
    const [isFolderLinking, setIsFolderLinking] = useState(false);

    const handleClick = async () => {
        const isFolderMode = mode === 'folder';
        if (isUploading || (isFolderMode && isFolderLinking)) return;

        if (isFolderMode) {
            setIsFolderLinking(true);
        }

        openOneDrivePicker(isFolderMode ? 'folder' : 'files', filters ? { filters } : {})
            .then((result) => {
                if (isFolderMode) {
                    if (result && onFolderSelected) {
                        console.log('Pasta selecionada (folder mode):', result);
                        onFolderSelected(result);
                    }
                } else {
                    if (!result) {
                        console.log('Nenhum arquivo selecionado');
                        return;
                    }
                    const files = Array.isArray(result)
                        ? result
                        : (result.items || result.data || []);
                    const fileInfo = files.map(file => ({
                        name: file.name,
                        downloadUrl: file['@content.downloadUrl'],
                        size: file.size,
                        id: file.id,
                        webUrl: file.webUrl,
                        WebDavUrl: file.webDavUrl,
                    }));
                    if (onFilesSelected) {
                        onFilesSelected(fileInfo);
                    }
                }
            })
            .catch((error) => {
                console.error('Error opening OneDrive picker:', error);
            })
            .finally(() => {
                if (isFolderMode) {
                    setIsFolderLinking(false);
                }
            });
    };

    const label = buttonLabel != null ? buttonLabel : (mode === 'folder' ? 'Selecionar pasta OneDrive' : 'OneDrive');
    const disabled = isUploading || (mode === 'folder' && isFolderLinking);

    return (
        <div>
            <button
                type="button"
                className="one-drive-file-button"
                onClick={handleClick}
                disabled={disabled}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '10px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1,
                    textAlign: 'left',
                    fontFamily: 'inherit'
                }}
            >
                <img
                    src='imagens/onedrive.svg'
                    alt="OneDrive"
                />
                {showText && (
                    <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                        {label}
                    </span>
                )}
            </button>
        </div>
    );
}

export default OneDriveFileButton;